import styled from 'styled-components'

const ErrorMessageHeader = styled.div`
  font-size: 16px;
  font-weight: bold;
`

export default ErrorMessageHeader
